import React from 'react';

const ColdReadTerms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Terms of Use</h1>
      <p className="text-center text-gray-600 mb-4">ColdRead for iOS · Last updated: August 27, 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          These terms govern your use of the ColdRead app. By downloading or using ColdRead you agree to them. If you do not agree, do not use the app.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. The service</h2>
        <p>
          ColdRead is a rehearsal tool for actors: it imports or records scripts, reads other characters' lines aloud, listens to your delivery and helps you memorize lines. It is provided for personal, non-commercial rehearsal use.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Your content</h2>
        <p>
          You keep all rights to the scripts, recordings and notes you create or import. ColdRead claims no ownership of your content. You are responsible for ensuring you have the right to use, record and share any script you bring into the app, and for how you share exported files.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Free tier and ColdRead Pro</h2>
        <p>
          ColdRead can be used free of charge with limits (such as the number of scripts and lines and access to certain features). ColdRead Pro removes these limits and is sold as an auto-renewable subscription:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Payment is charged to your Apple ID at confirmation of purchase.</li>
          <li>The subscription renews automatically unless auto-renew is turned off at least 24 hours before the end of the current period. Your account is charged for renewal within 24 hours before the end of the current period at the price shown at purchase.</li>
          <li>You can manage or cancel your subscription in your Apple ID account settings. Cancellation takes effect at the end of the current billing period; refunds are handled by Apple under App Store terms.</li>
          <li>Prices may vary by region and may change; you will be notified in accordance with App Store rules before any price change applies to you.</li>
        </ul>
        <p>Limits of the free tier may change over time.</p>

        <h2 className="text-xl font-semibold mt-8">4. Acceptable use</h2>
        <p>
          You agree not to reverse engineer, tamper with or circumvent the app's licensing or purchase mechanisms, and not to use the app for unlawful purposes or in a way that infringes others' rights.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Speech recognition and accuracy</h2>
        <p>
          Speech recognition, PDF parsing and line matching are automated and can make mistakes. ColdRead is a practice aid, not a substitute for your own judgment, and we do not guarantee any particular rehearsal or memorization outcome.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Availability and changes</h2>
        <p>
          We may update, change or discontinue features at any time. We aim to keep the app working on supported iOS versions but cannot guarantee uninterrupted availability of features that rely on Apple services (such as speech recognition or system voices).
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Disclaimer of warranties</h2>
        <p>
          ColdRead is provided "as is" and "as available" without warranties of any kind, express or implied, including fitness for a particular purpose and non-infringement, to the fullest extent permitted by law.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, the developer is not liable for indirect, incidental, special or consequential damages, or for loss of data or content, arising from your use of the app. Our total liability for any claim relating to the app is limited to the amount you paid for the app in the twelve months before the claim.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Apple</h2>
        <p>
          These terms are between you and the developer, not Apple. Apple is not responsible for the app or its content and has no obligation to provide support for it. Apple and its subsidiaries are third-party beneficiaries of these terms and may enforce them against you. Your use of the app is also subject to Apple's Licensed Application End User License Agreement.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. Termination</h2>
        <p>
          You may stop using the app at any time by deleting it. We may suspend or terminate access if you breach these terms.
        </p>

        <h2 className="text-xl font-semibold mt-8">11. Governing law</h2>
        <p>
          These terms are governed by the laws of the Republic of Türkiye, without prejudice to mandatory consumer-protection rules of the country where you live.
        </p>

        <h2 className="text-xl font-semibold mt-8">12. Changes to these terms</h2>
        <p>
          We may revise these terms; the date at the top shows the latest version. Continued use of the app after a change means you accept the revised terms.
        </p>

        <h2 className="text-xl font-semibold mt-8">13. Contact</h2>
        <p>
          <a href="mailto:hi@n1inovasyon.com" className="text-blue-600 hover:text-blue-800">hi@n1inovasyon.com</a>
        </p>

        <div className="mt-12 p-4 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            ColdRead is developed by Zahid Esat Ağca. Contact: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600 hover:text-blue-800">hi@n1inovasyon.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ColdReadTerms;
